import controller from './routines-list.controller';
import template from './routines-list.view.html';

let RoutinesListComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default RoutinesListComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/routines-list/routines-list.component.js
 **/